var map = {
	"./blogs.svg": "5cfd",
	"./cart-btn.svg": "f520",
	"./cart.svg": "22db",
	"./contact.svg": "1e32",
	"./home-btn.svg": "6c39",
	"./home.svg": "af7d",
	"./products.svg": "7591",
	"./profile-circle-white-20x20.svg": "ab70",
	"./user-btn.svg": "d154"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "451f";